export var HTLCTransaction;
(function (HTLCTransaction) {
    HTLCTransaction["UserHTLCLock"] = "UserHTLCLock";
    HTLCTransaction["HTLCLock"] = "HTLCLock";
    HTLCTransaction["HTLCRedeem"] = "HTLCRedeem";
})(HTLCTransaction || (HTLCTransaction = {}));
